import { CommonModule } from '@angular/common';
import { Component, NgModule, OnInit } from '@angular/core';
import { FindInformationMegaMenuModule } from '@app/components/find-information/find-information-mega-menu/find-information-mega-menu.component';
import { FindInformationSavedPagesModule } from '@app/components/find-information/find-information-saved-pages/find-information-saved-pages.component';
import { FindInformationTrendingPagesModule } from '@app/components/find-information/find-information-trending-pages/find-information-trending-pages.component';
import { RequiredReadingModule } from '@app/components/required-reading/required-reading.component';
import { FeatureToggleModule } from '@app/directives/feature-toggle.directive';
import { HideParentIfEmptyModule } from '@app/directives/hide-parent-if-empty.directive';
import { MarkComponentVisitedModule } from '@app/directives/mark-component-visited.directive';
import { LinkModule } from '@app/directives/link.directive';
import { InfoboxZoneModule } from '@app/components/infobox-zone/infobox-zone.component';
import { FeatureSettingsStoreService } from '@app/services/feature-settings-store.service';

@Component({
  selector: 'app-find-information',
  templateUrl: './find-information.component.html',
  styleUrls: ['./find-information.component.scss']
})
export class FindInformationComponent implements OnInit {

  enableRightSection: boolean;
  constructor(private featureSettingsStoreService: FeatureSettingsStoreService) { }
  ngOnInit(): void {
    this.enableRightSection = this.featureSettingsStoreService.state.enableRightSection;
  }
}
@NgModule({
  declarations: [FindInformationComponent],
  exports: [FindInformationComponent],
  imports: [
    CommonModule,
    LinkModule,
    FeatureToggleModule,
    MarkComponentVisitedModule,
    HideParentIfEmptyModule,
    RequiredReadingModule,
    FindInformationMegaMenuModule,
    FindInformationTrendingPagesModule,
    FindInformationSavedPagesModule,
    InfoboxZoneModule
  ]
})
export class FindInformationModule { }
